export default "__VITE_ASSET__fa29c31d__"